import React from 'react'
import EmptyIcon from './icons/empty'
import PendingReviewIcon from './icons/pending-review'
import ApprovedIcon from './icons/approved'
import ConditionallyApprovedIcon from './icons/conditionally-approved'
import RejectedIcon from './icons/rejected'
import EsignRequestedIcon from './icons/esign-requested'
import NotRequiredIcon from './icons/not-required'
import styled from 'styled-components'
import { DocumentStatusOption } from '../constants'

const ContainerElement = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
  width: fit-content;
`

const IconWrapperElement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const TextElement = styled.p`
  font-weight: bold;
  font-size: 1.1rem;
  margin: 0;
`
const iconsMap = {
  [DocumentStatusOption.empty]: EmptyIcon,
  [DocumentStatusOption.pending_review]: PendingReviewIcon,
  [DocumentStatusOption.conditionally_approved]: ConditionallyApprovedIcon,
  [DocumentStatusOption.rejected]: RejectedIcon,
  [DocumentStatusOption.approve_and_commit]: ApprovedIcon,
  [DocumentStatusOption.not_required]: NotRequiredIcon,
  [DocumentStatusOption.esign_requested]: EsignRequestedIcon,
}

function Title({ title, status }) {
  const Icon = iconsMap[status]

  return (
    <ContainerElement>
      <IconWrapperElement>
        <Icon />
      </IconWrapperElement>
      <TextElement>{title}</TextElement>
    </ContainerElement>
  )
}

export default Title
